import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import Login from './views/Login.vue'

// import check_login from './views/check_login.vue'
import Register from './views/Register.vue'
import Menulift from './views/Menulift.vue'
// import Setupsender from './views/Setupsender.vue'
// import Setupsenderadd from './views/Setupsenderadd.vue'
// import Sendmessage from './views/Sendmessage.vue'
// import EditSendmessage from './views/EditSendmessage.vue'
// import Messagereport from './views/Messagereport.vue'
// import Takeoutreport from './views/Takeoutreport.vue'
// import Topuplist from './views/Topuplist.vue'
// import Setuser from './views/Setuser.vue'
// import Setuseradd from './views/Setuseradd.vue'
// import Usagedata from './views/Usagedata.vue'
import Logout from './views/Logout.vue'
// import Test1 from './views/Test1.vue'
Vue.use(Router)

export default new Router({
	mode: 'history',
	linkExactActiveClass: 'active',
	scrollBehavior: (to, from, savedPosition) => {
		if (savedPosition) {
			return savedPosition
		}
		if (to.hash) {
			return {selector: to.hash}
		}
		return {x: 0, y: 0}
	},
	routes: [
		{
			path: '/Login',
			name: 'Login',
			components: {default: Login},
		},
		// {
		// 	path: '/check_login',
		// 	name: 'check_login',
		// 	components: {header: check_login},
		// },
		{
			path: '/Register',
			name: 'Register',
			components: {default: Register},
		},
		{
			path: '/',
			name: 'Menulift',
			components: {header: Menulift},
		},
		{
			path: '/HomePage',
			name: 'HomePage',
			components: {header: Menulift},
		},

		{
			path: '/Setupsender',
			name: 'Setupsender',
			components: {header: Menulift},
		},
		{
			path: '/Setupsenderadd',
			name: 'Setupsenderadd',
			components: {header: Menulift},
		},
		{
			path: '/Sendmessage',
			name: 'Sendmessage',
			components: {header: Menulift},
		},
		{
			path: '/EditSendmessage',
			name: 'EditSendmessage',
			components: {header: Menulift},
		},
		{
			path: '/EditSendmessagelist',
			name: 'EditSendmessagelist',
			components: {header: Menulift},
		},
		{
			path: '/Messagereport',
			name: 'Messagereport',
			components: {header: Menulift},
		},
		{
			path: '/Takeoutreport',
			name: 'Takeoutreport',
			components: {header: Menulift},
		},
		{
			path: '/Topuplist',
			name: 'Topuplist',
			components: {header: Menulift},
		},
		{
			path: '/Setuser',
			name: 'Setuser',
			components: {header: Menulift},
		},
		{
			path: '/Setuseradd',
			name: 'Setuseradd',
			components: {header: Menulift},
		},
		{
			path: '/Usagedata',
			name: 'Usagedata',
			components: {header: Menulift},
		},
		{
			path: '/Manageuser',
			name: 'Manageuser',
			components: {default: Menulift},
		},
		{
			path: '/Managepromotion',
			name: 'Managepromotion',
			components: {default: Menulift},
		},
		{
			path: '/Managepromotionadd',
			name: 'Managepromotionadd',
			components: {default: Menulift},
		},
		{
			path: '/Managecredit',
			name: 'Managecredit',
			components: {default: Menulift},
		},
		{
			path: '/Logout',
			name: 'Logout',
			components: {default: Logout},
		},
		{
			path: '/Bankstatement',
			name: 'Bankstatement',
			components: {header: Menulift},
		},
		{
			path: '/Depositlist',
			name: 'Depositlist',
			components: {header: Menulift},
		},
		{
			path: '/AccountDeposit',
			name: 'AccountDeposit',
			components: {header: Menulift},
		},
		{
			path: '/AddAccountDeposit',
			name: 'AddAccountDeposit',
			components: {header: Menulift},
		},
		{
			path: '/RemainwaitConfirm',
			name: 'RemainwaitConfirm',
			components: {header: Menulift},
		},
		{
			path: '/ListDeposit',
			name: 'ListDeposit',
			components: {header: Menulift},
		},
		{
			path: '/Depositdemical',
			name: 'Depositdemical',
			components: {header: Menulift},
		},
	],
})
